import { Component } from '@angular/core';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html'
})

export class MainLayoutComponent  {
    constructor() { }
}